"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.waitForTransaction = exports.extractAccountNumberFromResponse = exports.extractSequenceFromResponse = exports.extractBalanceFromResponse = void 0;
var requests_utility_1 = require("./requests.utility");
var proto_1 = require("../../proto");
var crypto_1 = require("@cosmjs/crypto");
/**
 * Extracts the specific balance denomination from the ABCI response
 * @param {string | null} abciData the base64-encoded ABCI data
 * @param {string} denomination the required denomination
 */
var extractBalanceFromResponse = function (abciData, denomination) {
    // Make sure the response is initialized
    if (!abciData) {
        return 0;
    }
    // Extract the balances
    var balancesRaw = Buffer.from(abciData, 'base64')
        .toString()
        .replace(/"/gi, '');
    // Find the correct balance denomination
    var balances = balancesRaw.split(',');
    if (balances.length < 1) {
        return 0;
    }
    // Find the correct denomination
    var pattern = new RegExp("^(\\d+)".concat(denomination, "$"));
    for (var _i = 0, balances_1 = balances; _i < balances_1.length; _i++) {
        var balance = balances_1[_i];
        var match = balance.match(pattern);
        if (match) {
            return parseInt(match[1], 10);
        }
    }
    return 0;
};
exports.extractBalanceFromResponse = extractBalanceFromResponse;
/**
 * Extracts the account sequence from the ABCI response
 * @param {string | null} abciData the base64-encoded ABCI data
 */
var extractSequenceFromResponse = function (abciData) {
    // Make sure the response is initialized
    if (!abciData) {
        return 0;
    }
    try {
        // Parse the account
        var account = (0, requests_utility_1.parseABCI)(abciData);
        return parseInt(account.BaseAccount.sequence, 10);
    }
    catch (e) { }
    // Account not initialized,
    // return default value (0)
    return 0;
};
exports.extractSequenceFromResponse = extractSequenceFromResponse;
/**
 * Extracts the account number from the ABCI response
 * @param {string | null} abciData the base64-encoded ABCI data
 */
var extractAccountNumberFromResponse = function (abciData) {
    // Make sure the response is initialized
    if (!abciData) {
        throw new Error('account is not initialized');
    }
    try {
        // Parse the account
        var account = (0, requests_utility_1.parseABCI)(abciData);
        return parseInt(account.BaseAccount.account_number, 10);
    }
    catch (e) {
        throw new Error('account is not initialized');
    }
};
exports.extractAccountNumberFromResponse = extractAccountNumberFromResponse;
/**
 * Waits for the transaction to be committed to a block in the chain
 * of the specified provider. This helper does a search for incoming blocks
 * and checks if a transaction
 * @param {Provider} provider the provider instance
 * @param {string} hash the base64-encoded hash of the transaction
 * @param {number} [fromHeight=latest] the starting height for the search. If omitted, it is the latest block in the chain
 * @param {number} [timeout=15000] the timeout in MS for the search
 */
var waitForTransaction = function (provider, hash, fromHeight, timeout) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
                var currentHeight, _a, exitTimeout, fetchInterval;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!fromHeight) return [3 /*break*/, 1];
                            _a = fromHeight;
                            return [3 /*break*/, 3];
                        case 1: return [4 /*yield*/, provider.getBlockNumber()];
                        case 2:
                            _a = _b.sent();
                            _b.label = 3;
                        case 3:
                            currentHeight = _a;
                            exitTimeout = timeout ? timeout : 15000;
                            fetchInterval = setInterval(function () { return __awaiter(void 0, void 0, void 0, function () {
                                var latestHeight, blockNum, block, _i, _a, tx, txRaw, txHash;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0: return [4 /*yield*/, provider.getBlockNumber()];
                                        case 1:
                                            latestHeight = _b.sent();
                                            if (latestHeight < currentHeight) {
                                                // No need to parse older blocks
                                                return [2 /*return*/];
                                            }
                                            blockNum = currentHeight;
                                            _b.label = 2;
                                        case 2:
                                            if (!(blockNum <= latestHeight)) return [3 /*break*/, 5];
                                            return [4 /*yield*/, provider.getBlock(blockNum)];
                                        case 3:
                                            block = _b.sent();
                                            // Check if there are any transactions at all in the block
                                            if (!block.block.data.txs || block.block.data.txs.length == 0) {
                                                return [3 /*break*/, 4];
                                            }
                                            // Find the transaction among the block transactions
                                            for (_i = 0, _a = block.block.data.txs; _i < _a.length; _i++) {
                                                tx = _a[_i];
                                                txRaw = (0, requests_utility_1.base64ToUint8Array)(tx);
                                                txHash = (0, crypto_1.sha256)(txRaw);
                                                if ((0, requests_utility_1.uint8ArrayToBase64)(txHash) == hash) {
                                                    // Clear the interval
                                                    clearInterval(fetchInterval);
                                                    // Decode the transaction from amino
                                                    resolve(proto_1.Tx.decode(txRaw));
                                                }
                                            }
                                            _b.label = 4;
                                        case 4:
                                            blockNum++;
                                            return [3 /*break*/, 2];
                                        case 5:
                                            currentHeight = latestHeight + 1;
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, 1000);
                            setTimeout(function () {
                                // Clear the fetch interval
                                clearInterval(fetchInterval);
                                reject('transaction fetch timeout');
                            }, exitTimeout);
                            return [2 /*return*/];
                    }
                });
            }); })];
    });
}); };
exports.waitForTransaction = waitForTransaction;
